// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"94d232b2","985":"a451b4f5"}[chunkId] + ".chunk.css";
};